import CampaignsContainer from 'modules/campaigns/containers/CampaignsContainer';

const CampaignsView = props => <CampaignsContainer {...props} />;

export default CampaignsView;
